import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  withOverridableStyles,
  HistoryListImages,
} from '@bingads-webui-campaign-react/ads-studio-shared-components';
import {
  mergeClasses,
} from '@fluentui/react-components';
import {
  History20Regular,
} from '@fluentui/react-icons';

import { HistoryImagesViewAll, HistoryImagesViewLess, ViewMode } from './history-images';
import { getGenerationHistoryListStyles } from './generation-history-list-styles';


const HistoryListImpl = ({
  selectedIndex,
  historyList,
  onSelectHistory,
  i18n,
  classes,
}) => {
  const onClick = useCallback((index) => {
    onSelectHistory(historyList[index], index);
  }, [historyList, onSelectHistory]);

  const onKeyDown = useCallback((index, ev) => {
    if (ev.keyCode === 'Enter') {
      onClick(index);
    }
  }, [onClick]);

  return (
    <div className={mergeClasses('history-list-root', classes.historyListRoot)}>
      <div className="history-list-title-container">
        <History20Regular className="history-icon" />
        <div className="history-title">{i18n.getString(_TL_('History'))}</div>
      </div>
      <div className="history-list-container">
        <div className="history-list-images-container">
          <HistoryListImages onClick={onClick} onKeyDown={onKeyDown} historyList={historyList} selectedIndex={selectedIndex} />
        </div>
      </div>
    </div>
  );
};

HistoryListImpl.propTypes = {
  selectedIndex: PropTypes.number,
  historyList: PropTypes.arrayOf(PropTypes.shape({})),
  onSelectHistory: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

HistoryListImpl.defaultProps = {
  selectedIndex: -1,
  historyList: [],
  onSelectHistory: () => {},
};

export const GenerationHistoryList = withOverridableStyles(HistoryListImpl, getGenerationHistoryListStyles);

const HistoryListImplV2 = ({
  selectedHistoryGroup,
  historyList,
  onSelectHistory,
  i18n,
  classes,
}) => {
  const [viewMode, setViewModwe] = useState(ViewMode.VIEW_LESS);

  const onClick = useCallback((groupIndex, imageIndex) => {
    onSelectHistory(historyList[groupIndex], groupIndex, imageIndex);
  }, [historyList, onSelectHistory]);

  const onKeyDown = useCallback((groupIndex, imageIndex, ev) => {
    if (ev.keyCode === 'Enter') {
      onClick(groupIndex, imageIndex);
    }
  }, [onClick]);

  return (
    <div className={mergeClasses('history-list-root', classes.historyListRootV2)}>
      <div className="history-list-container">
        {viewMode === ViewMode.VIEW_LESS && (
          <HistoryImagesViewLess
            i18n={i18n}
            historyList={historyList}
            onClick={onClick}
            onKeyDown={onKeyDown}
            selectedHistoryGroup={selectedHistoryGroup}
            onClickViewAll={() => setViewModwe(ViewMode.VIEW_ALL)}
          />
        )}
        {viewMode === ViewMode.VIEW_ALL && (
          <HistoryImagesViewAll
            i18n={i18n}
            historyList={historyList}
            onClick={onClick}
            onKeyDown={onKeyDown}
            selectedHistoryGroup={selectedHistoryGroup}
            onClickViewLess={() => setViewModwe(ViewMode.VIEW_LESS)}
          />
        )}
      </div>
    </div>
  );
};

HistoryListImplV2.propTypes = {
  selectedHistoryGroup: { groupIndex: PropTypes.number, imageIndex: PropTypes.number },
  historyList: PropTypes.arrayOf(PropTypes.shape({})),
  onSelectHistory: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

HistoryListImplV2.defaultProps = {
  selectedHistoryGroup: { groupIndex: -1, imageIndex: -1 },
  historyList: [],
  onSelectHistory: () => {},
};

export const GenerationHistoryListV2 = withOverridableStyles(HistoryListImplV2, getGenerationHistoryListStyles);
